<script setup lang="ts">
// TODO: maybe do the items monochrome? using a css mask-image/clip-mask
const _props = defineProps<{ data: LogosProps; template?: 'page' | 'overlay' }>()

const duration = computed(() => (_props.data.logos?.length || 0) * 4)
</script>

<template>
  <section
    class="flex w-full overflow-hidden py-15 lg:py-16"
    :style="{ '--duration': duration + 's' }"
    :class="{
      'bg-neon-yellow': template !== 'overlay' && data.theme === 'neon-yellow',
      'bg-white':
        template !== 'page' &&
        template !== 'overlay' &&
        data.theme !== 'light-grey' &&
        data.theme !== 'neon-yellow',
      'bg-light-grey':
        template === 'page' || (template !== 'overlay' && data.theme === 'light-grey'),
    }"
  >
    <div
      v-for="index in 8"
      :key="index"
      class="flex shrink-0 animate-[marquee_var(--duration,_10s)_linear_infinite] items-center gap-10 pr-10 lg:gap-20 lg:pr-20"
    >
      <CommonMedia
        v-for="(logo, idx) in data.logos"
        :key="idx"
        :sizes="'200px'"
        class="h-4 shrink-0 lg:h-5"
        :fill="'h'"
        :media="logo"
      />
    </div>
  </section>
</template>
